import { css } from 'styled-components';

import { COLOR } from '#@/shared/utils/styles';

// IMPORTANT:
// Those styles are shared with `createRenderInputWithTrailingSuffix` so
// be careful adding or remove props that won't work for a `div` or that
// could break the positioning of the overlaid invisible text.
// When in doubt, just add the styles in `Styles.ts` instead.

export const borderlessOverrides = css`
  background: transparent;
  border-color: transparent;
  padding-inline: 0;
  margin-inline: 0;
`;

export const baseDisabledTextOverrides = css`
  color: ${COLOR.textTertiary};
`;
